module.exports = __webpack_public_path__ + "static/assets/e772f2b4f625f406e8bf913328d5c525.png";